var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
var USE_RETRIEVE_USER_EXTERNAL_MATCH_PERMISSIONS = "useRetrieveUserExternalMatchPermissions";
var USE_RETRIEVE_USER_INTRA_SQUAD_MATCH_PERMISSIONS = "useRetrieveUserIntraSquadMatchPermissions";
var USE_RETRIEVE_USER_INTRA_SQUAD_TOURNAMENT_PERMISSIONS = "useRetrieveUserIntraSquadTournamentPermissions";
var USE_RETRIEVE_USER_LEAGUE_PERMISSIONS = "useRetrieveUserLeaguePermissions";
var USE_RETRIEVE_USER_LEAGUE_MATCH_PERMISSIONS = "useRetrieveUserLeagueMatchPermissions";
var USE_RETRIEVE_USER_LEAGUE_MATCH_STATS_PERMISSIONS = "useRetrieveUserLeagueMatchStatsPermissions";
export var useRetrieveUserExternalMatchPermissions = function (_a) {
    var externalMatchId = _a.externalMatchId;
    return useQuery({
        queryKey: [USE_RETRIEVE_USER_EXTERNAL_MATCH_PERMISSIONS, externalMatchId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/permissions/external-matches/".concat(externalMatchId, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!externalMatchId,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveUserIntraSquadMatchPermissions = function (_a) {
    var intraSquadMatchId = _a.intraSquadMatchId;
    return useQuery({
        queryKey: [
            USE_RETRIEVE_USER_INTRA_SQUAD_MATCH_PERMISSIONS,
            intraSquadMatchId,
        ],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/permissions/intra-squad-matches/".concat(intraSquadMatchId, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!intraSquadMatchId,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveUserIntraSquadTournamentPermissions = function (_a) {
    var tournamentId = _a.tournamentId;
    return useQuery({
        queryKey: [
            USE_RETRIEVE_USER_INTRA_SQUAD_TOURNAMENT_PERMISSIONS,
            tournamentId,
        ],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/permissions/intra-squad-tournaments/".concat(tournamentId, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!tournamentId,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveUserLeaguePermissions = function (_a) {
    var leagueId = _a.leagueId;
    return useQuery({
        queryKey: [USE_RETRIEVE_USER_LEAGUE_PERMISSIONS, leagueId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/permissions/league/".concat(leagueId, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !!leagueId,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveUserLeagueMatchPermissions = function (_a) {
    var leagueMatchId = _a.leagueMatchId;
    return useQuery({
        queryKey: [USE_RETRIEVE_USER_LEAGUE_MATCH_PERMISSIONS, leagueMatchId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/permissions/league-matches/".concat(leagueMatchId, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveUserLeagueMatchStatsPermissions = function (_a) {
    var leagueMatchId = _a.leagueMatchId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_USER_LEAGUE_MATCH_STATS_PERMISSIONS, leagueMatchId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/permissions/league-match-stats/".concat(leagueMatchId, "/"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
